/**
 * REQUIREMENTS
 * window.appState.isStylesLoaded must be true when onLoad is done for stylesheets
 * window.appState.isStylesFailed must be true when onLoad is failed
 */

let isReady = false;
let isStarted = false;
let onSuccessOrErrorSubscribers = [];

export default function stylesFinally(callback) {
    if (isReady) {
        callback();
    } else {
        onSuccessOrErrorSubscribers.push(callback);
    }

    if (!isStarted) {
        isStarted = true;
        startCheckStyles();
    }
}

let timeoutId = null;

function startCheckStyles() {
    //window onLoad fallback
    window.addEventListener('load', onWindowLoadFallback);
    checkStylesReady();
}

function onWindowLoadFallback() {
    if (isReady) {
        return;
    }

    if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
    handleSuccessOrError();
}

function checkStylesReady() {
    if (isReady) {
        return;
    }

    if (window.appState) {
        if (window.appState.isStylesLoaded === true) {
            window.removeEventListener('load', onWindowLoadFallback);
            handleSuccessOrError();
            return;
        }
        if (window.appState.isStylesFailed === true) {
            handleSuccessOrError();
            return;
        }
    } else {
        console.error('no window.appState');
        return;
    }

    timeoutId = setTimeout(checkStylesReady, 75);
}

function handleSuccessOrError() {
    isReady = true;
    onSuccessOrErrorSubscribers.forEach(callback => callback());
}






// WEBPACK FOOTER //
// ./app/general/js/style-observer.js